export function openIntercomArticle(articleId: number) {
    // @ts-expect-error
    if (typeof window.Intercom !== 'undefined' && Analytics.intercomWasInitialized) {
        // @ts-expect-error
        window.Intercom('showArticle', articleId);
    }
}
